var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyNoteTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 254,
    viewBox: "0 0 258 254",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M64.9253 41.169C64.9253 41.169 103.538 70.4702 162.24 15.6817C214.373 -32.9756 256.94 43.7947 257.238 80.5583C257.625 128.183 205.105 166.287 230.592 197.568C256.08 228.848 180.047 280.501 139.07 235.799C88.0956 180.19 74.2856 225.372 45.2307 225.372C24.3775 225.372 -18.4363 173.557 10.4754 135.008C34.8042 102.57 21.5362 91.8043 15.1093 80.5583C5.84134 64.3392 27.853 20.3158 64.9253 41.169Z",
    fill: "#26303E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115.16 127.018H122.079V168.53H115.16V127.018Z",
    fill: "#999999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M135.918 127.018H142.837V168.53H135.918V127.018Z",
    fill: "#999999"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3242 99.6836L94.1228 106.497L100.936 107.699L88.9221 175.835C88.6035 177.642 89.0158 179.502 90.0683 181.005C91.1208 182.508 92.7273 183.532 94.5344 183.85L149.044 193.462C150.851 193.78 152.71 193.368 154.213 192.316C155.717 191.263 156.74 189.657 157.059 187.849L169.073 119.713L175.887 120.914L177.088 114.101L95.3242 99.6836ZM95.7358 177.037L107.75 108.9L162.259 118.512L150.245 186.648L95.7358 177.037Z",
    fill: "#999999"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4023 96.2856L146.775 57.7083L150.878 63.279L98.5056 101.856L94.4023 96.2856Z",
    fill: "#999999"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyNoteTrash);
export default __webpack_public_path__ + "static/media/EmptyNoteTrash.ecc0ab27.svg";
export { ForwardRef as ReactComponent };